export default __webpack_public_path__ + "static/media/home-desktop.76cc5455.jpg";